export default __webpack_public_path__ + "static/media/icon_account.0b09bda5.svg";